import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Customer from './Customer'
import { clearValue, setBooking, setPhone, setStep } from "../../../Reducer/bookingSlice"
import Trip from "./Trip";
import Payment from "./Payment";
import Booking from "./Booking";
import CustomerEdit from "./CustomerEdit";
import Handler from "../../../Helpers/Components/Handler";
import { reloadWindowToPath } from "../../../Helpers/Utils";
import Modal from "../../../Helpers/Components/Modal";
import { toast } from "react-toastify";
import { useAuth } from "../../../Contexts/AuthenticateProvider";

const Booked = () => {
    const navigate = useNavigate()
    const { id } = useParams()
    const [bookingId, setBookingId] = useState("")
    const [loading, setLoading] = useState(false)
    const { userDetails } = useAuth()
    const booking = useSelector(state => state.booking.booking)
    const step = useSelector(state => state.booking.step)
    const [preview, setPreview] = useState(false)
    const [searchParams] = useSearchParams();
    const name = searchParams.get("name");
    const number = searchParams.get("number");
    const dispatch = useDispatch()
    const getBookingDetails = async () => {
        setLoading(true)
        const response = await Handler({ method: 'get', url: `/booking/detail/${id}` })
        setLoading(false)
        if (response?.success) {
            const data = response?.data
            dispatch(setBooking({ ...response?.data?.booking, car: data?.car, carId: data?.booking?.carId, customer: data?.customer, firstName: data?.customer?.firstName, lastName: data?.customer?.lastName, phone: data?.customer?.phone?.length ? data?.customer?.phone?.filter(e => e.priority === 1)?.length ? data?.customer?.phone?.filter(e => e.priority === 1)[0] : {} : {} }))
            if (data?.booking?.deliveryDetails?.delivery && data?.booking?.pickupDetails?.pickup) {
                let diff = ((new Date(data?.booking?.pickupDetails?.pickup).getTime() - new Date(data?.booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600;
                if (Math.ceil(diff / 12) / 2 == 0.5) {
                    dispatch(setBooking({ totalDays: 1, halfDayOffer: 0, point: 0 }))
                } else {
                    dispatch(setBooking({ totalDays: Math.floor(Math.ceil(diff / 12) / 2) }));
                    if (Math.ceil(diff / 12) % 2 !== 0) {
                        let to = new Date(data?.booking?.pickupDetails?.pickup)
                        to?.setHours(new Date(data?.booking?.pickupDetails?.pickup)?.getHours() - 2)
                        let diff1 = ((to?.getTime() - new Date(data?.booking?.deliveryDetails?.delivery).getTime()) / 1000) / 3600
                        if (Math.ceil(diff1 / 12) % 2 !== 0) {
                            dispatch(setBooking({ point: 0.5 }))
                        } else {
                            dispatch(setBooking({ point: 0, halfDayOffer: 0 }))
                        }
                    } else {
                        dispatch(setBooking({ point: 0, halfDayOffer: 0 }))
                    }
                }
            }
            dispatch(setStep(Number(response?.data?.booking?.screen) > 3 ? 0 : Number(response?.data?.booking?.screen)))
        } else {
            reloadWindowToPath(`/booking/1`)
        }
    }
    const handleSubmit = async () => {
        setLoading(true)
        const response = await Handler({ method: 'patch', url: `/booking/details/third/update/${bookingId}`, data: { lead: booking?.lead } })
        if (response?.success) {
            setTimeout(() => {
                reloadWindowToPath(`/booking/1`)
            }, 1500);
            toast.success(response?.message)
        } else {
            setLoading(false)
            toast.error(response?.message)
        }

    }
    const updateSteps = async () => await Handler({ method: 'PATCH', url: `/booking/change/step/${bookingId}?step=${step}`, data: {} })
    useEffect(() => {
        dispatch(clearValue())
    }, [])
    useEffect(() => {
        if (name && number) {
            dispatch(setBooking({ firstName: name }))
            dispatch(setPhone({ phone: number, code: "+91" }))
        }
    }, [name, number])
    useEffect(() => {
        if (id) {
            setBookingId(id)
            getBookingDetails()
        }
    }, [id])
    const initialLoad = useRef(true);
    useEffect(() => {
        if (!bookingId) return;

        if (initialLoad.current) {
            initialLoad.current = false;
            return;
        }

        updateSteps();
    }, [step]);
    return (
        <React.Fragment>
            <div className="arrow-back"> <i onClick={() => navigate(-1)} className="fa-solid fa-arrow-left fs-5 cursor-pointer"></i> </div>
            <h5 className="text-center text-theme fs-4">Booking {id ? "Update" : "Register"}</h5>
            <h6 className="text-center">Pre Booking - Advance Booking</h6>
            <div className="layout-card mt-4">
                {
                    id ?
                        <div className="inside-fixed">
                            <div className="text-center fs-5 mb-3 fw-bold">Status: {booking?.status || "Initiated"}</div>
                            <div className="row">
                                <div className="text-center col-sm-4"><span className="topTitle">Booking ID : </span>{(booking?.bookingId ? booking?.bookingId : "-")}</div>
                                <div className="text-center col-sm-4"><span className="topTitle">Cust ID : </span>{(booking?.customerId ? booking?.customerId : "-")}</div>
                                <div className="text-center col-sm-4"><span className="topTitle">Booked Date : </span>{(booking?.createdAt ? moment(booking?.createdAt)?.format("DD/MM/YYYY") : "-")}</div>
                            </div>
                            <hr className="mb-5" />
                        </div>
                        : ""
                }
                <div className="row">
                    <div className="col-lg-3 d-lg-block d-flex justify-content-between mb-lg-0 mb-4 tab-col">
                        <div className="d-flex align-items-center gap-2">
                            <span className={`${step === 0 ? "active-tab" :
                                (step > 0 ? "completed-tab" : "")
                                } round-span`}>{step > 0 ? <i className="fa-solid fa-check"></i> : "1"}</span>
                            <div className={`register-tabs d-lg-block d-none`}>Customer Info</div>
                        </div>
                        <div className="d-flex align-items-center gap-2 my-lg-4 my-0">
                            <span className={`${step === 1 ? "active-tab" :
                                (step > 1 ? "completed-tab" : "")
                                } round-span`}>{step > 1 ? <i className="fa-solid fa-check"></i> : "2"}</span>
                            <div className="register-tabs d-lg-block d-none">Trip Info</div>
                        </div>
                        <div className="d-flex align-items-center gap-2  my-lg-4 my-0">
                            <span className={`${step === 2 ? "active-tab" :
                                (step > 2 ? "completed-tab" : "")
                                } round-span`}>{step > 2 ? <i className="fa-solid fa-check"></i> : "3"}</span>
                            <div className="register-tabs d-lg-block d-none">Payment Info</div>
                        </div>
                        <div className="d-flex align-items-center gap-2  my-lg-4 my-0">
                            <span className={`${step === 3 ? "active-tab" :
                                (step > 3 ? "completed-tab" : "")
                                } round-span`}>{step > 3 ? <i className="fa-solid fa-check"></i> : "4"}</span>
                            <div className="register-tabs d-lg-block d-none">Booking Info</div>
                        </div>
                    </div>
                    <div className="col-lg-9">
                        {
                            step === 0 ?
                                id ? <CustomerEdit bookingId={bookingId} /> : <Customer />
                                : step === 1 ?
                                    <Trip setBookingId={setBookingId} bookingId={bookingId} />
                                    : step === 2 ?
                                        <Payment bookingId={bookingId} />
                                        : step === 3 ?
                                            <Booking bookingId={bookingId} setPreview={setPreview} />
                                            : ""
                        }
                    </div>
                </div>
            </div>
            <Modal fullScreen={"true"} header="Preview" size={'lg'} onShow={preview} footerClassname={'justify-content-center'} toggle={() => setPreview(false)} overlayToggle={() => setPreview(false)}>
                <div className="row justify-content-center mb-3 align-items-stretch">
                    <div className="row px-3">
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Customer ID </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={booking?.customerId} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Customer Name </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={(booking?.firstName || "") + " " + (booking?.lastName || "")} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row px-3">
                        <div className="col-lg-4">
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Mobile </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" value={(booking?.phone?.code || "") + "" + (booking?.phone?.phone || "")} id="modalInput" readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row p-3">
                        <div className="col-lg-4">
                            <div className="form_title mb-4 text-center fw-bold"> Trip Info</div>
                            <div className="row d-flex align-items-center mb-3">
                                <label className="col-sm-5 col-form-label" > Delivery Date and Time: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.deliveryDetails?.delivery ? moment(new Date(booking?.deliveryDetails?.delivery))?.format("DD/MM/YYYY hh:mm A") : ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Delivery Location: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.deliveryDetails?.location} readOnly />
                                </div>
                            </div>
                            <div className="row d-flex align-items-center mb-3">
                                <label className="col-sm-5 col-form-label" > Pickup Date and Time: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.pickupDetails?.pickup ? moment(new Date(booking?.pickupDetails?.pickup))?.format("DD/MM/YYYY hh:mm A") : ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" >  Pickup Location: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.pickupDetails?.location} readOnly />
                                </div>
                            </div>
                            <div className="form_title mb-4 text-center fw-bold"> Booking Info</div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Lead Mode: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.lead?.mode} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Lead Attended By: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.lead?.name || booking?.lead?.staffId} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Booking Given By: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={userDetails?.name || ""} readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="mt-3 mt-lg-0 col-lg-4">
                            <div className="form_title mb-3 text-center fw-bold"> Payment Info</div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Total Days: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.totalDays + booking?.point} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Cost per day: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={(Number(booking?.rentalFee || 0) - Number(booking?.offerPerDay || 0)) || 0} readOnly />
                                </div>
                            </div>
                            {
                                booking?.point === 0.5 ?
                                    <div className="row mb-3">
                                        <label className="col-sm-5 col-form-label" > Half day rent: </label>
                                        <div className="col-sm-7">
                                            <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={((Number(booking?.rentalFee || 0) / 2) - Number(booking?.halfDayOffer || 0)) || 0} readOnly />
                                        </div>
                                    </div> : ""
                            }
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Total Cost: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={
                                        (booking?.totalDays * (Number(booking?.rentalFee || 0) - Number(booking?.offerPerDay || 0))) + (booking?.point === 0.5 ? (Number(booking?.rentalFee || 0) / 2) - Number(booking?.halfDayOffer || 0) : 0) || 0
                                    } readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Delivery Charge: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.deliveryDetails?.price || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Pickup Charge: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.pickupDetails?.price || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Security Deposit: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.securityDeposit || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Advance Paid: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.advance?.paid || 0} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Advance Paid Mode: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.advance?.mode || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3 d-flex align-items-center">
                                <label className="col-sm-5 col-form-label" > Advance Paid Remarks: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.advance?.remarks || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Balance to be Paid: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.balancePaid || 0} readOnly />
                                </div>
                            </div>
                        </div>
                        <div className="mt-3 mt-lg-0 col-lg-4">
                            <div className="form_title mb-3 text-center fw-bold"> Vehicle Info</div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Car ID: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.carId || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Model: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.car?.model || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Color: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.car?.color || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Reg No: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.car?.registrationNo || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Fastag Bank: </label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.car?.fasTagType || ""} readOnly />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <label className="col-sm-5 col-form-label" > Type of Car:</label>
                                <div className="col-sm-7">
                                    <input className="form-control input-theme text-uppercase" autoComplete="off" id="modalInput" value={booking?.car?.segment || ""} readOnly />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mb-4 text-center"><button className="btn btn-success" disabled={loading} onClick={handleSubmit}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Submit"}</button></div>
            </Modal>
        </React.Fragment>
    )
}

export default Booked;